var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("svg", { attrs: { viewBox: "0 0 512 360" } }, [
    _c("g", { attrs: { transform: "translate(-40,257)" } }, [
      _c("rect", {
        staticStyle: {
          fill: "#2E4554",
          stroke: "#2E4554",
          "stroke-width": "50",
          "stroke-linejoin": "round"
        },
        attrs: { width: "440", height: "300", x: "70", y: "-228" }
      })
    ]),
    _vm._v(" "),
    _c(
      "g",
      {
        staticStyle: { display: "inline" },
        attrs: { transform: "translate(-55,260) scale(1.04)" }
      },
      [
        _c(
          "g",
          {
            attrs: {
              transform:
                "matrix(0.90519927,0,0,0.90519927,27.827776,-7.3475183)"
            }
          },
          [
            _c("g", [
              _c(
                "g",
                {
                  staticStyle: { fill: "#000000", stroke: "none" },
                  attrs: {
                    transform:
                      "matrix(0.01162608,0,0,-0.01336413,30.317378,140.5996)"
                  }
                },
                [
                  _c("path", {
                    staticStyle: {
                      fill: "#ffffff",
                      "fill-opacity": "1",
                      stroke: "none"
                    },
                    attrs: {
                      d:
                        "m 680,9996 c 8,-7 944,-706 2080,-1552 1136,-846 2411,-1796 2834,-2111 l 769,-573 31,23 c 17,13 1296,966 2841,2117 1546,1151 2814,2097 2819,2102 6,4 -2555,8 -5689,8 -4821,0 -5697,-2 -5685,-14 z",
                      transform:
                        "matrix(3.8403128,0,0,3.7629169,-1764.446,-7877.7676)"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticStyle: {
                      fill: "#f3f7f9",
                      "fill-opacity": "1",
                      stroke: "none"
                    },
                    attrs: {
                      d:
                        "m 626,7018 c -4,-1366 -6,-2856 -4,-3311 l 3,-828 1146,1308 c 631,719 1421,1621 1757,2005 l 610,696 -1721,1283 C 1470,8876 681,9464 664,9477 l -32,23 z",
                      transform:
                        "matrix(3.8403128,0,0,3.7629169,-1764.446,-7877.7676)"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticStyle: {
                      fill: "#ffffff",
                      "fill-opacity": "0.94117647",
                      stroke: "none"
                    },
                    attrs: {
                      d:
                        "m 12065,9482 c -11,-10 -789,-592 -1730,-1292 -940,-700 -1718,-1280 -1727,-1289 -16,-15 2,-39 290,-367 169,-193 955,-1090 1747,-1994 l 1440,-1643 3,1652 c 1,908 1,2394 0,3301 -3,1650 -3,1651 -23,1632 z",
                      transform:
                        "matrix(3.8403128,0,0,3.7629169,-1764.446,-7877.7676)"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticStyle: {
                      fill: "#dae2e6",
                      "fill-opacity": "1",
                      stroke: "none"
                    },
                    attrs: {
                      d:
                        "m 7335,5955 c -533,-398 -974,-721 -980,-717 -5,3 -441,327 -967,719 -527,392 -962,713 -967,713 -5,0 -762,-858 -1681,-1907 l -1672,-1908 2652,-3 c 1458,-1 3841,-1 5295,0 l 2643,3 -1669,1905 c -919,1048 -1673,1908 -1677,1912 -4,3 -443,-319 -977,-717 z",
                      transform:
                        "matrix(3.8403128,0,0,3.7629169,-1764.446,-7877.7676)"
                    }
                  })
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }